export default "__VITE_ASSET__Cn3iI0Iw__"